import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataTicket } from '../../data/DataTicket.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxTacheHub extends Component {

    static defaultProps = {
        idProjet: undefined,
        label: "Tâche",
        nomPhase: undefined,
        placeholder: "Tâche",
    };

    render = () => {

        const { idProjet, nomPhase } = this.props;

        // Les tâches hub sont nommées selon les mois de l'année
        // La méthode ci-dessous permet de trier les tâches en s'aidant d'un index récupéré dans le tableau DayPickerStrings
        const extractItems = (reponseAPIobjet) => {
            let items = EUIComboBox.defaultProps.extractItems(reponseAPIobjet);
            const months = Scriba.traduction().stringsTermes().fr.DayPickerStrings.months.map(month => month.toLowerCase());
            items = items.map(item => {
                const index = months.indexOf(item.nom.toLowerCase());
                return { ...item, index };
            });
            return items.sort((a, b) => a.index - b.index);;
        }

        let fetchMethod = null;
        if (!!idProjet && !!nomPhase)
            fetchMethod = () => DataTicket._chargementDesTachesHub(idProjet, nomPhase);

        return <EUIComboBox
            {...this.props}
            extractItems={extractItems}
            fetchMethod={fetchMethod}
            itemKey={item => item.idTache}
            itemText={item => item.nom}
            stamp={[idProjet, nomPhase]}
        />;

    };

};